import {
Component,
ContentChild,
Injector,
Optional,
TemplateRef
} from '@angular/core';
import {CommonModule} from "@angular/common";
import { WmsTranscludeDirective } from '../../page/wms-transclude/wms-transclude.directive';
import { DialogFooterDirective } from '../dialog-footer/dialog-footer.directive';
import { setCSS, runtimeEventManager, setAttr } from '@wm/core';

import { DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, styler, register, getSheetPositionClass } from "@wm/components-base";


const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-dialog',
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};

@Component({
  selector: '[wmDialog]',
  template: `
    <div class="app-view dialog-view clearfix">
      <div class="app-dialog modal-dialog" [ngStyle]="{width: width}" *ngIf="loadDialogContent">
        <div class="modal-content">
          <div class="app-dialog-header modal-header" title="{{hint}}" *ngIf="showheader">
            <button ng-if="closable" aria-label="Close" class="app-dialog-close close" [ngClass]="{'btn-text': isPrism}" title="{{this.appLocale.LABEL_DIALOG_CLOSE}}">
              <span class="app-icon wi wi-clear" aria-hidden="true"></span>
            </button>
            
            <ng-container [ngSwitch]="headinglevel">
              <ng-container *ngSwitchCase="'h1'">
                <h1 class="app-dialog-title modal-title">
                  <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
                </h1>
              </ng-container>
              <ng-container *ngSwitchCase="'h2'">
                <h2 class="app-dialog-title modal-title">
                  <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
                </h2>
              </ng-container>
              <ng-container *ngSwitchCase="'h3'">
                <h3 class="app-dialog-title modal-title">
                  <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
                </h3>
              </ng-container>
              <ng-container *ngSwitchCase="'h4'">
                <h4 class="app-dialog-title modal-title">
                  <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
                </h4>
              </ng-container>
              <ng-container *ngSwitchCase="'h5'">
                <h5 class="app-dialog-title modal-title">
                  <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
                </h5>
              </ng-container>
              <ng-container *ngSwitchCase="'h6'">
                <h6 class="app-dialog-title modal-title">
                  <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
                </h6>
              </ng-container>
              <ng-container *ngSwitchDefault>
                <h4 class="app-dialog-title modal-title">
                  <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
                </h4>
              </ng-container>
            </ng-container>
            <ng-template #headerTemplate>
              <img data-identifier="img" [src]="iconurl" ng-if="iconurl" ng-style="{width:iconwidth ,height:iconheight, margin:iconmargin}" />
              <i class="{{iconclass}}" [ngStyle]="{width:iconwidth, height:iconheight, margin:iconmargin}" *ngIf="iconclass && !iconurl"></i>
              <span class="dialog-heading" [title]="title">{{ title }}</span>
            </ng-template>
            <div class="wm-dialog-header-action" *ngIf="actiontitle || actionlink">
              <i [title]="actiontitle" class="wm-icon wms wms-help"></i>
              <a [href]="actionlink" target="_blank">{{ this.appLocale.LABEL_HELP }}</a>
            </div>
          </div>
          <div class="app-dialog-body modal-body {{contentclass}}" [ngStyle]="{height: height}" wmsTransclude>
            <ng-container *ngTemplateOutlet="dialogBody"></ng-container>
          </div>
          <ng-container *ngTemplateOutlet="dialogFooter"></ng-container>
          <!-- <div ng-transclude="footer"></div> -->
          <!-- <div wmDialogFooter class="app-dialog-footer modal-footer" data-identifier="actions" init-widget wmsTransclude>
            <ng-content></ng-content>
          </div> -->

        </div>
      </div>
    </div>`,
  providers: [
    provideAsWidgetRef(DesignDialogComponent)
  ],
  exportAs: 'wmDialog',
  standalone: true,
  imports: [ CommonModule, WmsTranscludeDirective, DialogFooterDirective ],
  styles: []
})
export class DesignDialogComponent extends StylableComponent {
  static initializeProps = register('wm-dialog');
  override height: string;
  override width:string
  showheader: boolean;
  hint: string;
  iconurl: string;
  iconclass: string;
  dialogid: string;
  title: string;
  iconmargin: string;
  iconheight: string;
  iconwidth: string;
  actiontitle: string;
  contentclass: string;
  actionlink: string;
  loadDialogContent: boolean = false;
  headinglevel: string = 'h4';
  sheetposition: string;
  isPrism: boolean;

  @ContentChild('dialogBody', {read:TemplateRef}) dialogBody: TemplateRef<any>;
  @ContentChild('dialogFooter', {read: TemplateRef}) dialogFooter: TemplateRef<any>;

  constructor(inj: Injector,
              @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
    const projectService = runtimeEventManager.getService('projectService');
    this.isPrism = projectService.isPrism();
    this.registerPropertyChangeListener((key: string, nv: any, ov?: any) => {
      if (key === "height") {
        setCSS(this.nativeElement as HTMLElement, key, 'auto');
        const el = this.nativeElement.querySelector('.dialog-view .app-dialog') as HTMLElement;
        if (el) {
          setCSS(el, key, 'auto');
        }
      }else if (key === "width") {
        setCSS(this.nativeElement as HTMLElement, key, '100%');
      }
      if (key === "sheet") {
        let isSheet = nv === true;
        let widgetProperties = this.widgetProps;
        widgetProperties['sheetposition'].show = isSheet;
        this.$element.toggleClass("modal-sheet", isSheet);
        let sheetpositionClass = this.sheetposition ?  getSheetPositionClass(this.sheetposition) : getSheetPositionClass('right');
        if(!isSheet) { 
          // if sheet toggle is disabled remove sheetposition class and attr
          this.$element.removeClass(sheetpositionClass);
          this.$element.removeAttr('sheet').removeAttr('sheetposition');
          this.$attrs.set('sheetposition', '');
        } else {
          // if sheet toggle is enabled use previously selected value from direction dropdown
          this.$element.attr('sheet', 'true');
          this.$element.attr('sheetposition', this.sheetposition);
          this.$element.addClass(getSheetPositionClass(this.sheetposition));
        }
        runtimeEventManager.emit('wms:refresh-properties-panel');
      }
      if (key === "sheetposition") {
        let isSheet = this.getAttr("sheet");
        this.$attrs.set('sheetposition', nv);
        if(isSheet) {
          this.$element.attr('sheetposition', nv);
          this.$element.removeClass(getSheetPositionClass(ov)).addClass(getSheetPositionClass(nv));
        }
      }
    });
  }
  override get stylerEl(): HTMLElement | null {
    return this.nativeElement.querySelector('.modal-dialog');
  }

  override onStyleChange(key: string, nv: any, ov?: any) {
    if (key === 'height' && nv !== ov) {
      this.$element.find('.modal-body').css('height', nv);
    }
  }
}

